/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ItemType = {
    Photo: 'PHOTO',
    Video: 'VIDEO'
} as const;
export type ItemType = typeof ItemType[keyof typeof ItemType];


export function instanceOfItemType(value: any): boolean {
    for (const key in ItemType) {
        if (Object.prototype.hasOwnProperty.call(ItemType, key)) {
            // @ts-ignore
            if (ItemType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ItemTypeFromJSON(json: any): ItemType {
    return ItemTypeFromJSONTyped(json, false);
}

export function ItemTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ItemType {
    return json as ItemType;
}

export function ItemTypeToJSON(value?: ItemType | null): any {
    return value as any;
}

